package gr.tech.GRAttestation.models.storeusers

import kotlinx.serialization.Serializable

@Serializable
data class StoreUserFinishRegistrationRequest(
    val registerToken: String,
    val email: String,
    val firstName: String,
    val lastName: String,
    val password: String,
)
